import { render } from "./VarTextEditor.vue?vue&type=template&id=70764bc6&scoped=true"
import script from "./VarTextEditor.vue?vue&type=script&lang=js"
export * from "./VarTextEditor.vue?vue&type=script&lang=js"

import "./VarTextEditor.vue?vue&type=style&index=0&id=70764bc6&scoped=true&lang=css"
import "./VarTextEditor.vue?vue&type=style&index=1&id=70764bc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70764bc6"]])

export default __exports__